import { bulk as bulkUpdate } from './update';

export function request(sportId, data) {
    return {
        type: 'MARKET_TEMPLATES_GET_LIST_REQUEST',
        sportId,
        data
    };
}

export function error(sportId, errors) {
    return {
        type: 'MARKET_TEMPLATES_GET_LIST_ERROR',
        sportId,
        errors
    };
}

export function finish(sportId, items) {
    return (dispatch) => {
        dispatch(bulkUpdate(items));

        dispatch({
            type: 'MARKET_TEMPLATES_GET_LIST_FINISH',
            sportId,
            items
        });
    };
}
